export const LIKE_AUTHENTICATION_ERROR_MESSAGE = 'Oops! Please sign in to save.';
export const LIKE_ERROR_MESSAGE = 'Oops! We had trouble saving. Please try again.';
export const LIKE_SUCCESS_MESSAGE = 'Saved in Your Content';
export const UNLIKE_AUTHENTICATION_ERROR_MESSAGE = 'Oops! Please sign in to manage your saves.';
export const UNLIKE_ERROR_MESSAGE = 'Oops! We had trouble removing the save. Please try again.';
export const UNLIKE_SUCCESS_MESSAGE = 'Your content save has been removed.';
